import BannerHeader from "../../../Components/BannerHeader/BannerHeader"
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav"
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo"
import classes from "./LeatherBinding.module.css"

import AboutLeatherBinding from "./AboutLeatherBinding/AboutLeatherBinding"
import Gallery from "../../Body/Gallery/Gallery"
import CustomerReview from "../../Body/CustomerReview/CutomerReview"
import FAQ from "../FAQ/FAQ"
import { ContactUs } from "../Components/ContactUs/ContactUs"
import Footer from "../../Footer/Footer"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { fetchAllVideos } from "../../../Store/actions/ServiceVideoAction"
import BookCustomization from "./BookCustomization/BookCustomization"
import { getAllFaq } from "../../../Store/actions/FaqAction"
import { urls } from "../../../Routes/Urls"
import useScrollToTop from "../../../Hooks/useScrollToTop";
import SEO from "../../../Components/SEO"
const bgImage = "/Assets/Images/ServicePages/LeatherBinding.png"

const LeatherBinding = () => {
    const crumbs = [
        {title:"Home",path:("/")},
        {title:"Leather Binding",path:urls.LEATHERBINDING},
    ]

    const allFaqs = useSelector(state => state.Faq.questions);
    const video = useSelector((state) => state.serviceVideo.videos);
    const dispatch = useDispatch();
    useEffect(() => {
        fetchAllVideos(dispatch)
        getAllFaq("category","Leather Binding","",dispatch)
    },[])

    const scrollRef = useScrollToTop();

    return(
    <>
        <SEO
            keywords="Leather book binding"
            title="Get Premium Leather Book Binding Services at Rare Biblio"
            description="At Rare Biblio, we offer custom premium leather book binding services that redefine excellence. Enhance your collection with expert craft—place your order now!"
            canonicalUrl="https://www.rarebiblio.com/leather-book-binding-services"
            structuredData={{
                "@context": "https://schema.org",
                "@graph": [
                  {
                    "@type": "Service",
                    "name": "Leather Book Binding Services",
                    "description": "Explore high-quality leather book binding services at Rare Biblio. Handcrafted covers, antique restorations, and premium finishing for your valuable books.",
                    "provider": {
                      "@type": "Organization",
                      "name": "Rare Biblio",
                      "url": "https://www.rarebiblio.com/",
                      "logo": {
                        "@type": "ImageObject",
                        "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
                      },
                      "sameAs": [
                        "https://www.facebook.com/rarebiblio/",
                        "https://www.instagram.com/Rarebiblio/",
                        "https://www.linkedin.com/company/Rarebiblio",
                        "https://in.pinterest.com/rare_biblio/",
                        "https://x.com/Rarebiblio"
                      ]
                    },
                    "areaServed": {
                      "@type": "Place",
                      "name": "Worldwide"
                    },
                    "serviceType": "Leather Book Binding",
                    "url": "https://www.rarebiblio.com/leather-book-binding-services"
                  },
                  {
                    "@type": "FAQPage",
                    "mainEntity": [
                      {
                        "@type": "Question",
                        "name": "What types of leather options are available for binding?",
                        "acceptedAnswer": {
                          "@type": "Answer",
                          "text": "We offer a wide range of premium leather types, including smooth, textured, and distressed finishes, as well as a variety of colors to suit your style. From rich, classic tones to unique, modern hues, you can select the leather that perfectly complements your book’s theme or your personal taste. If you're unsure, our team is happy to guide you through the options."
                        }
                      },
                      {
                        "@type": "Question",
                        "name": "Can I personalize my leather-bound book?",
                        "acceptedAnswer": {
                          "@type": "Answer",
                          "text": "Absolutely! Personalization is a key feature of our service. You can add custom engravings, such as your name, book title, date, or any special message, to the cover of your leather book. We offer various fonts and styles to match your vision. Whether it's for a gift, a special occasion, or personal use, we make sure your book feels unique."
                        }
                      },
                      {
                        "@type": "Question",
                        "name": "I have a book of my own. Can you leather bind it?",
                        "acceptedAnswer": {
                          "@type": "Answer",
                          "text": "Yes, we can! We offer free pickup and delivery for your book, and we'll carefully leather bind it for you, ensuring it meets your expectations."
                        }
                      },
                      {
                        "@type": "Question",
                        "name": "Do you do sewn binding or glued binding?",
                        "acceptedAnswer": {
                          "@type": "Answer",
                          "text": "Our usual process involves thread-sewn binding, which ensures durability and a premium finish. However, if you prefer glued binding, we can accommodate that request as well. Just let us know your preference!"
                        }
                      }
                    ]
                  }
                ]
              }}
        />
        <div ref={scrollRef}>
            <PrimaryNav />
            <BannerHeader 
            bgImage={bgImage}
            crumbs={crumbs} title={'Online Leather Book Binding Services'} desc={"Leather-bound books: where stories meet legacy."}/>

            <ServiceVideo title={"Online Custom Leather Book Binding."} desc={"We are happy to share our passion for finely produced leather bookbinding. We've been perfecting this traditional art for over a decade, motivated by our love of books and the timeless appeal of leather. "} videoSrc={video?.leatherBindingVideo}/>

            <AboutLeatherBinding />

            <BookCustomization />

            <Gallery />

            <CustomerReview />

            <FAQ data={allFaqs} />

            <div className={classes.contactUs}>
                <ContactUs category={"leatherBinding"} />
            </div>

            <Footer />
        </div>
    </>
    )
}

export default LeatherBinding